import { html, View } from 'rune-ts';
import { type ProgressProps } from './index';
import klass from './Progress.module.scss';

export class ProgressBar extends View<ProgressProps> {
  protected override template() {
    const { start, end, klass: custom_klass, auto = true } = this.data;
    return html`
      <div class="${klass.progress_bar} ${custom_klass || ''}">
        <div
          class="${klass.progress_bar_fill}"
          style="width: ${auto ? start : Math.min(100, Math.max(0, end))}%;"
          data-is-fill
        ></div>
      </div>
    `;
  }
}
